document.addEventListener('DOMContentLoaded', function() {
	const triggers = document.querySelectorAll('.modal-trigger');

	if (triggers) {
		triggers.forEach(trigger => {
			trigger.addEventListener('click', function(event) {
				event.preventDefault();

				const triggerClasses = Array.from(trigger.classList);
				const popupTriggerClass = triggerClasses.find(className =>
					 className.endsWith('-popup-trigger') && className !== 'modal-trigger'
				);

				if (popupTriggerClass) {
					const popupClass = popupTriggerClass.replace('-trigger', '');
					const popup = document.querySelector(`.${popupClass}`);

					if (popup) {
						popup.classList.add('is-active');
					}
				}
			});
		});

		document.addEventListener('click', function(event) {
			if ( event.target.parentNode.classList.contains('modal-trigger') ) {
				return;
			}

			const allPopups = document.querySelectorAll('[class*="-popup"]');

			allPopups.forEach(popup => {
				if (popup.classList.contains('is-active')) {
					const popupClasses = Array.from(popup.classList);
					const popupClass = popupClasses.find(className => className.endsWith('-popup'));

					if (popupClass) {
						const triggerClass = popupClass + '-trigger';

						if (
							 !popup.contains(event.target) &&
							 !event.target.classList.contains(triggerClass) &&
							 !event.target.closest(`.${triggerClass}`)
						) {
							popup.classList.remove('is-active');
						}
					}
				}
			});
		});
	}
});